import { Pipe, PipeTransform } from '@angular/core';

import { OrderStatusStatus } from '../../lib/lib-shared/types/OrderStatusStatus';

const orderStatusLabels: Partial<Record<OrderStatusStatus, string>> = {
  [OrderStatusStatus.CREATE]: 'Créée',
  [OrderStatusStatus.FACTORY_PACK]: 'Expédiée',
  [OrderStatusStatus.PICKUP_RECEIVED]: 'Disponible au point relais',
  [OrderStatusStatus.RETURN_DELIVERED]: 'Retournée',
  [OrderStatusStatus.RETURN_SENT]: 'Retournée',
  [OrderStatusStatus.FINISH]: 'Livrée',
};

@Pipe({
  name: 'orderStatus',
  standalone: false,
})
export class OrderStatusPipe implements PipeTransform {
  transform(status: OrderStatusStatus): string {
    return orderStatusLabels[status] ?? status;
  }

}
